import starIcon from '~/assets/icons/star_quest.svg';
import taskIcon from '~/assets/icons/task_daily.svg';
import { HudTaskType } from '~/shared';

export const questTypesStyles = {
	[HudTaskType.QUEST]: {
		text: 'ОСНОВНОЕ ЗАДАНИЕ',
		icon: starIcon,
		backgroundColor: '#FABE2C',
		textColor: '#000000',
	},
	[HudTaskType.DAILY]: {
		text: 'ЕЖЕДНЕВНОЕ ЗАДАНИЕ',
		icon: taskIcon,
		backgroundColor: '#FFF1C3',
		textColor: '#262628',
	},
};
